import React from 'react'
import {Container} from 'react-bootstrap'
import CompLinkHeaders from 'components/riwayat/compLinkHeader'
import {Link} from "react-router-dom"
import './style.css'
import Navbar from 'components/dashboard/navbar'
import Footer from 'components/dashboard/footer'

export default function point() {
    return (
        <>
          <Navbar />
            <Container className="comp-point-page">
                <CompLinkHeaders to="/profile" back="Profil Saya" title="Point" Ctitle="point-malmora" />
                <Bonus kupon="Jumlah Poin Anda" poin="30 Poin" tukarPoin="Tukar Poin" />
                <h6>Riwayat Poin</h6>
                <Bonus containe="tabel-transaksi-malmora" borderClass="border" poinPlus="tabel-poin" kupon="Transaksi Malmora"  tukarPoin="+30 Poin" />
                <h6>Tukar Poin</h6>
                <TukarPoin />
            </Container>
           <Footer />
        </>
    )
}


function Bonus(props) {
    return (
        <div className={`containe-comp ${props.containe}`}>
           <div className={`pembungkus-comp ${props.borderClass}`} >
            <div className={`jumlah-poin ${props.potonganClass}`}>
                <div className={props.syaratClass}>
                    <p className={props.kuponClass}>{props.kupon}</p>
                    <p className={props.smallClass}>{props.poin}</p>
                </div>
            </div>
            <div className={`tukar-poin`}>
                <p className={props.poinPlus}>{props.tukarPoin}</p>
                <p className={props.btnClass}>{props.btnPoin}</p>
            </div>
           </div>
        </div>
    )
}

function TukarPoin() {
    return (
        <div className="containe-tukar-poin">
            {
                Datas.map((data, idx) => {
                    return (
                        <div key={idx} className="kupon-text">
                        <div className="text-content">
                            <img src="asset/users/img-kupon.svg" alt="kupon" />
                            <div className="text">
                                <h6>{data.kupon}</h6>
                                <small>{data.syarat}</small>
                            </div>
                        </div>
                        <div className="text-point-tukar">
                            <p>{data.poin}</p>
                            <p className="btn-tukar">{data.btn}</p>
                        </div>
                    </div>
                    )
                })
            }
            <br/><br/><br/><br/>
            <Link to="#">Lihat selanjutnya</Link>
        </div>
    )
}

const Datas = [
    {kupon:"Kupon Potongan Harga Rp. 50.000", syarat:"Syarat dan Ketentuan", poin:"10 Poin", btn:"Tukar Poin"},{kupon:"Kupon Potongan Harga Rp. 100.000", syarat:"Syarat dan Ketentuan", poin:"50 Poin", btn:"Tukar Poin"}
]
